<template>
  <div class="central-ajuda">
    <Breadcrumb :items="breadcrumbItems" />

    <h1 class="page-title">Central de Ajuda</h1>

    <div class="content-grid">
      <aside class="topics-panel">
        <h2 class="panel-title">Procure por tópicos</h2>

        <Carregamento v-if="isLoadingTopico" />
        <ul
          class="topics-list"
          v-else
        >
          <li
            v-for="topico in topicos"
            :key="topico.id"
            :class="[
              'topic-item',
              {
                active: topico.id === route.query.topico,
                editing: editingTopicId === topico.id,
              },
            ]"
          >
            <template v-if="editingTopicId === topico.id">
              <input
                class="topic-edit-input"
                type="text"
                v-model="editTopicoValue"
                @keyup.enter="confirmEditTopico"
                @keyup.esc="cancelEditTopico"
                autofocus
              />
              <div
                class="topic-edit-actions"
                v-show="isAdmin"
              >
                <button
                  class="icon-btn confirm"
                  title="Salvar"
                  @click="confirmEditTopico"
                >
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M5 13l4 4L19 7"
                      stroke="currentColor"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <button
                  class="icon-btn cancel"
                  title="Cancelar"
                  @click="cancelEditTopico"
                >
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6 6l12 12M18 6L6 18"
                      stroke="currentColor"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </template>

            <template v-else>
              <span
                class="topic-label"
                @click="selectTopic(topico.id)"
                >{{ topico.nome }}</span
              >
              <div
                class="topic-actions"
                v-show="isAdmin"
              >
                <button
                  class="icon-btn"
                  title="Editar tópico"
                  @click.stop="startEditTopico(topico)"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 20h9"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <button
                  class="icon-btn danger"
                  title="Remover tópico"
                  @click.stop="removeTopico(topico)"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0l-1 14a2 2 0 01-2 2H7a2 2 0 01-2-2L4 6h16z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </template>
          </li>
          <li v-show="isAdmin">
            <form class="cadastro-topico-container">
              <span>Adicionar Tópico</span>
              <input
                class="topico-input"
                type="text"
                placeholder="Nome Tópico"
                required
                v-model="newTopico"
              />
              <button
                @click.prevent="salvarTopico"
                :disabled="isSavingTopico || newTopico === ''"
              >
                Adicionar
              </button>
            </form>
          </li>
        </ul>
      </aside>
      <section class="tutorials-panel">
        <div class="header">
          <h2 class="panel-title">Tutoriais</h2>
          <button
            v-show="isAdmin"
            class="btn-primary"
            @click="abrirModal('cadastro-tutorial')"
            :disabled="!checkTopicoAtivo()"
          >
            Adicionar Tutorial
          </button>
        </div>
        <Carregamento v-if="isLoadingTutorial" />

        <div
          class="accordion"
          v-else
        >
          <div
            v-if="checkTopicoAtivo()"
            v-for="tutorial in tutoriais"
            :key="tutorial.id"
            class="accordion-item"
          >
            <button
              class="accordion-header"
              :class="{ active: openTutorialId === tutorial.id }"
              @click="toggleTutorial(tutorial.id)"
            >
              <span>{{ tutorial.titulo }}</span>
              <svg
                class="chevron"
                :class="{ open: openTutorialId === tutorial.id }"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M6 9l6 6 6-6"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

            <div
              v-show="openTutorialId === tutorial.id"
              class="accordion-body"
            >
              <div
                class="tutorial-actions"
                v-show="isAdmin"
              >
                <button
                  class="icon-btn btn-secondary"
                  @click="editarTutorial(tutorial.id)"
                >
                  <span>Editar </span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 20h9"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <button
                  class="icon-btn danger btn-secondary"
                  @click="removeTutorial(tutorial)"
                >
                  <span>Remover </span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0l-1 14a2 2 0 01-2 2H7a2 2 0 01-2-2L4 6h16z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
              <p class="tutorial-description">{{ tutorial.descricao }}</p>
              <VideoPlayer
                v-if="tutorial.urlVideo && openTutorialId === tutorial.id"
                :url="tutorial.urlVideo"
              />
            </div>
          </div>
          <div
            class="empty-state"
            v-else
          >
            <svg
              class="empty-state-icon"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M4 6h16M4 12h10M4 18h7"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
              />
            </svg>
            <h6 class="empty-state-text">
              Selecione um tópico para visualizar seus tutoriais
            </h6>
          </div>
          <div
            class="empty-state"
            v-if="!checkTopicoAtivo && checkTutoriaisTopico()"
          >
            <svg
              class="empty-state-icon"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M4 6h16M4 12h10M4 18h7"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
              />
            </svg>
            <h6 class="empty-state-text">
              O tópico não possui tutoriais, cadastre um novo tutorial no botão
              acima
            </h6>
          </div>
        </div>
      </section>
    </div>

    <footer class="support-section">
      <h3>Suporte técnico</h3>
      <p>Tem alguma outra dúvida? Fale conosco agora.</p>
      <p>
        Mande um e-mail para
        <a href="mailto:nerds.ufc@gmail.com">nerds.ufc@gmail.com</a>
        ou
        <a href="mailto:prex.gabinete@gmail.com">prex.gabinete@gmail.com</a>
      </p>
    </footer>
  </div>
  <RouterView />
  <FormTutorialAjuda
    v-if="checkModal('tutorial')"
    @voltar="atualizarPagina()"
  />
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useTopicos } from "@/composables/useTopicos";
import { useTutoriais } from "@/composables/useTutoriais";
import { RouterView, useRoute } from "vue-router";
import router from "@/router";
import Carregamento from "@/components/common/Carregamento.vue";
import FormTutorialAjuda from "@/components/ajuda/formTutorialAjuda.vue";
import VideoPlayer from "@/components/common/VideoPlayer.vue";
import { useAuthStore } from "@/stores/auth";
import Breadcrumb from "@/components/common/Breadcrumb.vue";

const breadcrumbItems = computed(() => {
  return [
    { label: "Início", to: "/" },
    { label: "Central de Ajuda", to: "/ajuda" },
  ];
});

const route = useRoute();

const authStore = useAuthStore();

const {
  isLoadingTopico,
  isSavingTopico,
  topicos,
  fetchAllTopicos,
  saveTopico,
  updateTopico,
  deleteTopico,
} = useTopicos();

const {
  isLoadingTutorial,
  tutoriais,
  fetchTutoriaisByTopicoId,
  deleteTutorial,
} = useTutoriais();

const isAdmin = computed(() => {
  return (
    authStore.hasRole("ADMIN") ||
    authStore.hasRole("PREX_ADMIN") ||
    authStore.hasRole("ADMINISTRADOR")
  );
});

const newTopico = ref("");

const openTutorialId = ref("");

const editingTopicId = ref(null);
const editTopicoValue = ref("");

function startEditTopico(topico) {
  editingTopicId.value = topico.id;
  editTopicoValue.value = topico.nome;
}

function cancelEditTopico() {
  editingTopicId.value = null;
  editTopicoValue.value = "";
}

function confirmEditTopico() {
  const nome = editTopicoValue.value.trim();
  if (!nome) return;

  const payload = {
    nome,
    label: nome.toLowerCase(),
  };

  updateTopico(editingTopicId.value, payload);
  cancelEditTopico();
}

function removeTopico(topico) {
  const confirmado = window.confirm(
    `Remover o tópico "${topico.nome}"? Essa ação não pode ser desfeita.`
  );
  if (!confirmado) return;

  deleteTopico(topico.id);
}

function salvarTopico() {
  const payload = {
    nome: newTopico.value,
    label: newTopico.value.toLowerCase(),
  };

  saveTopico(payload);
  newTopico.value = "";
}

function selectTopic(id) {
  const query = { ...route.query };
  query.topico = id;

  openTutorialId.value = "";

  router.push({ query: query });
}

function toggleTutorial(id) {
  openTutorialId.value = openTutorialId.value === id ? null : id;
}

function checkModal(modal) {
  if (modal === "tutorial") {
    return route.query.modal === "cadastro-tutorial";
  }
}

function checkTopicoAtivo() {
  return route.query.topico;
}

function checkTutoriaisTopico() {
  console.log(tutoriais.value.length);
  return tutoriais.value.length === 0;
}

function editarTutorial(tutorialId) {
  const query = { ...route.query };
  query["tutorial-editado"] = tutorialId;
  query.modal = "cadastro-tutorial";

  router.push({ query });
}

function abrirModal(modal) {
  const query = { ...route.query };
  query.modal = modal;

  router.push({ query: query });
}

function atualizarPagina() {
  fetchTutoriaisByTopicoId(route.query.topico);
  fetchAllTopicos();
}

async function removeTutorial(tutorial) {
  const confirmacao = confirm(
    `Tem certeza que deseja excluir o tutorial ${tutorial.titulo}, do tópico ${tutorial.topicoAjudaNome}?`
  );

  if (confirmacao) {
    await deleteTutorial(tutorial.id);
    atualizarPagina();
  }
}

watch(
  () => route.query.topico,
  (newValue) => {
    fetchTutoriaisByTopicoId(newValue);
    console.log(tutoriais.value);
  }
);

onMounted(() => {
  fetchAllTopicos();

  if (route.query.topico) {
    fetchTutoriaisByTopicoId(route.query.topico);
  }
});
</script>

<style scoped>
.central-ajuda {
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 24px;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: var(--cinza-escuro);
}

.page-title {
  margin: 0 0 24px;
}

/* Layout */
.content-grid {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 24px;
  align-items: start;
}

.panel-title {
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 16px;
}

/* Sidebar de tópicos */
.topics-panel {
  border: 1px solid var(--cinza-claro);
  border-radius: 10px;
  padding: 20px;
}

.topics-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.topic-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 14px;
  border-bottom: 1px solid var(--cinza-claro);
  border-radius: 6px;
  color: var(--cinza-escuro);
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
}

.topic-item:last-child {
  border-bottom: none;
}

.topic-item:hover {
  background-color: var(--roxo-superficie);
}

.topic-item:hover .topic-actions {
  opacity: 1;
}

.topic-item.active {
  background-color: var(--roxo-superficie);
  color: var(--roxo-claro);
  font-weight: 600;
  border-bottom-color: transparent;
}

.topic-item.editing {
  background-color: var(--roxo-superficie);
}

.topic-label {
  cursor: pointer;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 10px 0px 10px 12px;
}

.topic-actions {
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.15s ease;
  padding: 10px 12px 10px 0px;
}

.topic-item.active .topic-actions {
  opacity: 1;
}

.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  height: 26px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--cinza-medio);
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
  flex-shrink: 0;
}

.icon-btn:hover {
  background-color: var(--roxo-superficie);
  color: var(--roxo-claro);
}

.icon-btn.danger:hover {
  background-color: var(--vermelho-claro);
  color: var(--vermelho);
}

.icon-btn.confirm:hover {
  background-color: var(--verde-claro);
  color: var(--verde);
}

.topic-edit-input {
  flex: 1;
  min-width: 0;
  padding: 5px 8px;
  font-size: 14px;
  border: 1px solid var(--roxo-claro);
  border-radius: 6px;
  outline: none;
}

.topic-edit-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.cadastro-topico-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: min-content;
  padding: 12px 12px;
  margin-top: 15px;
  width: 220px;
  border: 1px solid var(--roxo-claro);
  border-radius: 10px;
  font-size: 14px;
}

.cadastro-topico-container > span {
  align-self: center;
  position: absolute;
  margin-top: -22px;
  background-color: var(--branco);
  color: var(--roxo-claro);
}

.cadastro-topico-container > button {
  width: 100%;
  background-color: var(--roxo-claro);
  color: var(--branco);
  border-radius: 6px;
}

.cadastro-topico-container > button:disabled {
  background-color: hsla(258, 70%, 58%, 0.447);
  cursor: default;
}

.cadastro-topico-container > input {
  padding: 0 10px;
  border-bottom: 1px solid var(--cinza-medio);
}

/* Painel de tutoriais */
.tutorials-panel {
  border: 1px solid var(--cinza-claro);
  border-radius: 10px;
  padding: 20px;
}

.tutorial-actions {
  display: flex;
  flex-direction: row;
  gap: 15px;
  margin-bottom: 15px;
}

h2 {
  margin: 0px !important;
}

.tutorials-panel > .header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.accordion {
  border: 2px solid var(--cinza-claro);
  border-radius: 8px;
  overflow: hidden;
}

.accordion-item {
  border-bottom: 1px solid var(--cinza-claro);
}

.accordion-item:last-child {
  border-bottom: none;
}

.accordion-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--branco);
  border: none;
  padding: 14px 16px;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  color: var(--cinza-escuro);
  transition: background-color 0.15s ease;
}

.accordion-header:hover {
  background-color: var(--roxo-superficie);
}

.accordion-header.active {
  background-color: var(--roxo-superficie);
  color: var(--roxo-medio);
  font-weight: 600;
}

.chevron {
  flex-shrink: 0;
  transition: transform 0.2s ease;
  color: currentColor;
}

.chevron.open {
  transform: rotate(180deg);
}

.accordion-body {
  padding: 16px;
  background-color: var(--branco);
}

.tutorial-description {
  font-size: 13px;
  line-height: 1.6;
  color: var(--cinza-escuro);
  margin: 0 0 16px;
}

.video-placeholder {
  width: 100%;
  max-width: 320px;
  aspect-ratio: 16 / 10;
  background-color: var(--cinza-escuro);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-button {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background-color: hsla(0, 0%, 100%, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* Suporte técnico */
.support-section {
  margin-top: 40px;
}

.support-section h3 {
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 8px;
}

.support-section p {
  font-size: 14px;
  color: var(--cinza-escuro);
  margin: 4px 0;
}

.support-section a {
  color: var(--roxo-medio);
  text-decoration: underline;
}

.btn-primary {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: var(--branco);
  background-color: var(--roxo-claro);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.btn-primary:disabled {
  background-color: hsla(258, 70%, 58%, 0.447);
  cursor: default;
}

.btn-secondary {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: var(--roxo-claro);
  background-color: var(--branco);
  border: 1px solid var(--roxo-claro);
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.btn-secondary:hover {
  background-color: var(--roxo-superficie);
  border: 1px solid var(--roxo-claro);
  color: var(--roxo-claro);
}

.btn-secondary.danger:hover {
  background-color: var(--vermelho-claro);
  border: 1px solid var(--vermelho);
  color: var(--vermelho);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 20px;
  text-align: center;
  color: var(--cinza-medio);
  border: 1px dashed var(--cinza-claro);
  border-radius: 8px;
}

.empty-state-icon {
  color: var(--roxo-claro);
}

.empty-state-text {
  font-size: 14px;
  font-weight: 500;
  color: var(--cinza-medio);
  margin: 0;
}

/* Responsivo */
@media (max-width: 768px) {
  .content-grid {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}
</style>
